// extracted by mini-css-extract-plugin
export default {"quality-assurance-filter-root":"QualityAssuranceFilter_quality-assurance-filter-root__j8uLj","checkboxes":"QualityAssuranceFilter_checkboxes__cxb5+"};